import React from 'react';
import { NavLink  } from "react-router-dom";

import HeroSection from '../sections/HeroSection/HeroSection';
import BasicSection from '../sections/BasicSection/BasicSection';
import AddressAllegroSection from '../sections/AddressAllegroSection/AddressAllegroSection';
import MoreDescriptionSection from '../sections/MoreDescriptionSection/MoreDescriptionSection';
import DescriptionSection from '../sections/DescriptionSection/DescriptionSection';
import GridSection from '../sections/GridSection/GridSection';
import WycenaEtykietSection from '../sections/WycenaEtykietSection/WycenaEtykietSection';

const Rolka = () => (
    <React.Fragment>
        <HeroSection image="./assets/poligrafia_more_banner.jpg" />
        {/* <BasicSection
            title="druk na rolce"
            image="./assets/naklejka_na_rolce.png"
            theme="black"
            rightColumn={
                <React.Fragment>
                    <img src="./assets/rolka_big.png" class="specyfic-up-image"/>
                    <p>
                    - Aliquam placerat ex quis ullamcorper bibendum.<br />
                    - Duis id justo auctor, feugiat lectus in, aliquam sapien.<br />
                    - Etiam ac leo blandit felis malesuada rhoncus in in nulla.<br />
                    - Mauris consectetur odio vel semper rhoncus.
                    </p>
                </React.Fragment>
            }
        />
        <BasicSection
            title="technologia druku"
            image="./assets/big_zembatki.png"
            theme="blue"
            rightColumn={
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam efficitur augue et elit feugiat feugiat. Nulla justo purus, iaculis eget mollis at, dictum ac velit. Donec luctus hendrerit eros sit amet venenatis. Nam commodo tellus vulputate, elementum metus id, molestie sapien. Pellentesque facilisis ipsum urna, nec scelerisque nisl gravida ut. Aliquam erat volutpat. Donec imperdiet ornare odio. Ut non enim vel est tempus vehicula vestibulum ac velit. In luctus augue at ligula consectetur, id hendrerit turpis mollis. In efficitur ipsum orci, et accumsan velit egestas sit amet. Ut a pharetra quam. 
                  
                </p>
            }
        />
        <BasicSection
            title="dostępne materiały"
            theme="white"
            rightColumn={
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam efficitur augue et elit feugiat feugiat. Nulla justo purus, iaculis eget mollis at, dictum ac velit. Donec luctus hendrerit eros sit amet venenatis. Nam commodo tellus vulputate, elementum metus id, molestie sapien. Pellentesque facilisis ipsum urna, nec scelerisque nisl gravida ut. Aliquam erat volutpat. Donec imperdiet ornare odio. Ut non enim vel est tempus vehicula vestibulum ac velit. In luctus augue at ligula consectetur, id hendrerit turpis mollis. In efficitur ipsum orci, et accumsan velit egestas sit amet. Ut a pharetra quam. 
                  
                </p>
            }
            leftColumn={
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam efficitur augue et elit feugiat feugiat. Nulla justo purus, iaculis eget mollis at, dictum ac velit. Donec luctus hendrerit eros sit amet venenatis. Nam commodo tellus vulputate, elementum metus id, molestie sapien. Pellentesque facilisis ipsum urna, nec scelerisque nisl gravida ut. Aliquam erat volutpat. Donec imperdiet ornare odio. Ut non enim vel est tempus vehicula vestibulum ac velit. In luctus augue at ligula consectetur, id hendrerit turpis mollis. In efficitur ipsum orci, et accumsan velit egestas sit amet. Ut a pharetra quam. 
                  
                </p>
            }
        />
        <BasicSection
            title="uszlachetnianie"
            image="./assets/big_uszlachetnianie.png"
            theme="blue"
            rightColumn={
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam efficitur augue et elit feugiat feugiat. Nulla justo purus, iaculis eget mollis at, dictum ac velit. Donec luctus hendrerit eros sit amet venenatis. Nam commodo tellus vulputate, elementum metus id, molestie sapien. Pellentesque facilisis ipsum urna, nec scelerisque nisl gravida ut. Aliquam erat volutpat. Donec imperdiet ornare odio. Ut non enim vel est tempus vehicula vestibulum ac velit. In luctus augue at ligula consectetur, id hendrerit turpis mollis. In efficitur ipsum orci, et accumsan velit egestas sit amet. Ut a pharetra quam. 
                  
                </p>
            }
        />
        <BasicSection
            title="szerokości, długości, średnice..."
            image="./assets/bit_wielkosci_dlugosci.png"
            className="full-photo"
            theme="white"
            leftColumn={
                <p>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam efficitur augue et elit feugiat feugiat. Nulla justo purus, iaculis eget mollis at, dictum ac velit. Donec luctus hendrerit eros sit amet venenatis. Nam commodo tellus vulputate, elementum metus id, molestie sapien. Pellentesque facilisis ipsum urna, nec scelerisque nisl gravida ut. Aliquam erat volutpat. Donec imperdiet ornare odio. Ut non enim vel est tempus vehicula vestibulum ac velit. In luctus augue at ligula consectetur, id hendrerit turpis mollis. In efficitur ipsum orci, et accumsan velit egestas sit amet. Ut a pharetra quam. 
                  
                </p>
            }
        /> */}
        <GridSection
            title="sposoby nawoju etykiet"
            grids={
                [{
                    title: 'na zewnątrz',
                    classNameChild: 'col-6 col-lg-3',
                    grid: [
                        { element: <div><img src="./assets/naklejka_prawa_przod.png" alt=""/><h6>z prawej do przodu</h6></div> },
                        { element: <div><img src="./assets/naklejka_lewa_przod.png" alt=""/><h6>z lewej do przodu</h6></div> },
                        { element: <div><img src="./assets/naklejka_spod_przod.png" alt=""/><h6>spodem do przodu</h6></div> },
                        { element: <div><img src="./assets/naklejka_gora_przod.png" alt=""/><h6>górą do przodu</h6></div> }
                    ]
                },
                {
                    title: 'do środka',
                    classNameChild: 'col-6 col-lg-3',
                    grid: [
                        { element: <div><img src="./assets/naklejka_srodek_prawy_przod.png" alt=""/><h6>z prawej do przodu</h6></div> },
                        { element: <div><img src="./assets/naklejka_srodek_lewy_przod.png" alt=""/><h6>z lewej do przodu</h6></div> },
                        { element: <div><img src="./assets/naklejka_srodek_spod_przod.png" alt=""/><h6>spodem do przodu</h6></div> },
                        { element: <div><img src="./assets/naklejka_srodek_gora_przod.png" alt=""/><h6>górą do przodu</h6></div> }
                    ]
                }]
            }
            theme="blue"
        />
        <WycenaEtykietSection type="expirienced" title="Wycena etykiet na roli" />
        <DescriptionSection
            imageButton="./assets/galeria-link.png"
            imageLink="realizacje"
        >
            <NavLink to="/arkusz">
                <img className="image-button" alt="" src="./assets/wydruk-link.png"/>
            </NavLink>
        </DescriptionSection>
        <MoreDescriptionSection
            img="./assets/naklejka_karton.png"
            text={
                <div>
                    Istnieje możliwość wydruku próbnego<br/>- dzięki któremu przetestują Państwo jakość druku oraz kleju.<br/>
                    <b>Zamów wydruk próbny: <a href="tel:509-631-155">+48 509 631 155</a>, <a href="mailto:biuro@printlabel.pl">biuro@printlabel.pl</a></b>
                </div>
            }
        />
        <AddressAllegroSection />
    </React.Fragment>
)

export default Rolka;